import { render, staticRenderFns } from "./activityDetection.vue?vue&type=template&id=862b7f0a&scoped=true"
import script from "./activityDetection.vue?vue&type=script&lang=js"
export * from "./activityDetection.vue?vue&type=script&lang=js"
import style0 from "./activityDetection.vue?vue&type=style&index=0&id=862b7f0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "862b7f0a",
  null
  
)

export default component.exports